import React from "react";
import { Link } from "react-router-dom";

const BlogCardSmall = ({ image, title, link }) => {
  return (
    <Link
      to={link}
      className="blog-card d-flex align-items-end text-white text-decoration-none"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "33.33%",
        // borderRadius: "10px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div className="blog-overlay position-absolute w-100 h-100"></div>
      <div className="blog-content p-3 w-100 h-100 position-relative d-flex flex-column justify-content-between">
        <h5 className="mb-0 fw-light">{title}</h5>
        <p className="text-lora text-accent fs-6 fw-semibold"><i>Read More</i></p>
      </div>
    </Link>
  );
};



export default  BlogCardSmall;
